module.exports = __webpack_public_path__ + "esquina.png?fb887c22e9b972bf3faf457c525415dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/esquina.png
// module id = 733
// module chunks = 0